import { useState } from "react";
import { Menu, X } from "lucide-react";
import { TigolaLogo } from "@/components/TigolaLogo";
import { Button as UIButton } from "@/components/ui/button";

export default function Header() {
  const [open, setOpen] = useState(false);

  const navItems = [
    { href: "/", label: "Ride" },
    { href: "/taxi", label: "Cities" },
    { href: "/airports", label: "Airports" },
    { href: "/drive", label: "Drive" },
    { href: "/business", label: "Business" },
    { href: "/help", label: "Help" },
    { href: "/safety", label: "Safety" },
    { href: "/blog", label: "Blog" },
    { href: "/about", label: "About" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <header className="bg-white border-b shadow-sm sticky top-0 z-50 backdrop-blur-sm bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <a href="/" aria-label="Tigola - Home" className="flex-shrink-0">
              <TigolaLogo size="md" />
            </a>
          </div>
          <div className="flex items-center space-x-3">
            <UIButton
              asChild
              className="inline-flex bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold shadow-lg hover:shadow-xl transition-all duration-200 text-xs sm:text-sm"
            >
              <a href="/book-online" aria-label="Book Online">
                Book Online
              </a>
            </UIButton>
            <UIButton asChild>
              <a href="/app?src=website" aria-label="Download Tigola App">
                Get App
              </a>
            </UIButton>
            <button
              type="button"
              className="p-2"
              aria-label="Toggle menu"
              aria-expanded={open}
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <X className="h-6 w-6 text-gray-700" />
              ) : (
                <Menu className="h-6 w-6 text-gray-700" />
              )}
            </button>
          </div>
        </div>

        {/* Menu Dropdown */}
        {open && (
          <div className="absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-40">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-2">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50 transition-colors"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
